export default __webpack_public_path__ + "static/media/yellow-down.13b6c94e.svg";